import {Product, getMinimalProductPrice} from "@/entities/product";
import {dataLayerPush} from "@/Helpers/Function";

export const trackProductClick = (product: Product) => {
    dataLayerPush(
        'select_item',
        'catalog',
        'selectItem',
        'product',
        '',
        [{
            ...product,
            product_id: product.id,
            count: 1,
            price: getMinimalProductPrice(product),
        }]
    );
};
